import React from 'react'
import { Image, Button, Modal } from "react-bootstrap";
import {
  ModalButton,
  ModalTitle,
  ModalText,
  ModalImage,
} from './latestNewsubmitStyle'
import NonprofitImage from '../../../assests/images/latestnewsubmit.svg';
import { useNavigate } from 'react-router-dom';
import { MESSAGE } from '../../../utils/message';

interface LatestNewSubmitModalProps {
  EditLatestNewSubmitOpen: boolean;
  SetLatestNewSubmitOpen: (val: boolean) => void;
}
const LatestNewSubmitModal: React.FC<LatestNewSubmitModalProps> = ({ EditLatestNewSubmitOpen, SetLatestNewSubmitOpen }: any) => {
  const navigate = useNavigate();

  return (
    <Modal show={EditLatestNewSubmitOpen} className='claim-nonprofit-modal'
      onHide={() => SetLatestNewSubmitOpen(false)} centered>
      <Modal.Header closeButton></Modal.Header>
      <Modal.Body>
        <ModalImage> <Image src={NonprofitImage} /></ModalImage>
        <ModalTitle>{MESSAGE.awesomeTitle}</ModalTitle>
        <ModalText> {MESSAGE.LatestNewSubmitDescription}</ModalText>
        <ModalButton>
          <Button className='fill-btn modal-btn' onClick={() => { SetLatestNewSubmitOpen(false); navigate("/awards/browse") }}> {MESSAGE.topRatedNonprofitsBtn}</Button>
          <Button className='blank-btn modal-btn' onClick={() => {
            SetLatestNewSubmitOpen(false);
            window.location.href = `${import.meta.env.VITE_BLOG_URL}`;
          }}>{MESSAGE.readBlogBtn}</Button>
        </ModalButton>
      </Modal.Body>
    </Modal>
  )
}

export default LatestNewSubmitModal;